(() => {
  const roots = document.querySelectorAll('[data-kl-product-addons]');
  if (!roots.length) return;

  const routes = (window.KROWN && KROWN.settings && KROWN.settings.routes) || {};
  const addUrl = `${routes.cart_add_url || '/cart/add'}.js`;
  const changeUrl = `${routes.cart_change_url || '/cart/change'}.js`;

  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Cart fetch failed');
    return res.json();
  }

  async function postJson(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data.status === 422) {
      throw new Error(data.description || data.message || 'Cart update failed');
    }
    return data;
  }

  function findItem(cart, variantId) {
    const id = Number(variantId);
    return (cart.items || []).find((item) => Number(item.variant_id) === id);
  }

  function setCardUI(card, qty) {
    const addBtn = card.querySelector('[data-kl-addon-add]');
    const stepper = card.querySelector('[data-kl-addon-stepper]');
    const qtyEl = card.querySelector('[data-kl-addon-qty]');
    if (!addBtn || !stepper || !qtyEl) return;

    const hasQty = Number(qty) > 0;
    addBtn.hidden = hasQty;
    stepper.hidden = !hasQty;
    qtyEl.textContent = hasQty ? String(qty) : '1';
  }

  async function refreshThemeCart(openDrawer) {
    if (typeof window.refreshCart === 'function' && document.getElementById('AjaxCartForm')) {
      if (openDrawer) {
        window.refreshCart();
        return;
      }
    }

    try {
      const res = await fetch('?section_id=helper-cart');
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const formSource = doc.getElementById('AjaxCartForm');
      const subtotalSource = doc.getElementById('AjaxCartSubtotal');
      const cartItems = document.getElementById('AjaxCartForm');
      if (formSource && cartItems) {
        cartItems.innerHTML = formSource.innerHTML;
        if (typeof cartItems.ajaxifyCartItems === 'function') cartItems.ajaxifyCartItems();
        document.querySelectorAll('[data-header-cart-count]').forEach((el) => {
          const count = cartItems.querySelector('[data-cart-count]');
          if (count) el.textContent = count.textContent;
        });
      }
      const subtotalTarget = document.getElementById('AjaxCartSubtotal');
      if (subtotalSource && subtotalTarget) {
        subtotalTarget.innerHTML = subtotalSource.innerHTML;
      }
    } catch (e) {
      console.warn('[KL add-ons] theme cart refresh failed', e);
    }
  }

  function initRoot(root) {
    const viewport = root.querySelector('[data-kl-addon-viewport]');
    const track = root.querySelector('[data-kl-addon-track]');
    const cards = Array.from(root.querySelectorAll('[data-kl-addon-card]'));
    if (!track || !cards.length) return;

    const prev = root.querySelector('[data-kl-addon-prev]');
    const next = root.querySelector('[data-kl-addon-next]');

    function cardStep() {
      const card = cards[0];
      if (!card || !viewport) return 120;
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function updateNav() {
      if (!viewport || (!prev && !next)) return;
      const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth - 1);
      if (prev) prev.disabled = viewport.scrollLeft <= 1;
      if (next) next.disabled = viewport.scrollLeft >= maxScroll;
    }

    function scrollByCard(direction) {
      if (!viewport) return;
      viewport.scrollBy({ left: direction * cardStep(), behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', () => scrollByCard(-1));
    if (next) next.addEventListener('click', () => scrollByCard(1));
    if (viewport) {
      viewport.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
      updateNav();
    }

    async function syncAll() {
      try {
        const cart = await getCart();
        cards.forEach((card) => {
          const item = findItem(cart, card.dataset.variantId);
          setCardUI(card, item ? item.quantity : 0);
          if (item && item.key) card.dataset.itemKey = item.key;
          else delete card.dataset.itemKey;
        });
      } catch (e) {
        console.warn('[KL add-ons] sync failed', e);
      }
    }

    async function updateCard(card, action) {
      const variantId = Number(card.dataset.variantId);
      if (!variantId) return;

      root.dataset.busy = 'true';
      try {
        const cart = await getCart();
        const item = findItem(cart, variantId);
        let openDrawer = false;

        if (action === 'add' || (action === 'plus' && !item)) {
          await postJson(addUrl, { id: variantId, quantity: 1 });
          openDrawer = true;
        } else if (item) {
          const nextQty = Math.max(0, item.quantity + (action === 'plus' ? 1 : -1));
          await postJson(changeUrl, { id: item.key, quantity: nextQty });
        }

        await syncAll();
        await refreshThemeCart(openDrawer);
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      } catch (e) {
        console.warn('[KL add-ons] action failed', e);
        alert(e.message || 'Could not update cart. Please try again.');
      } finally {
        delete root.dataset.busy;
      }
    }

    root.addEventListener('click', (event) => {
      const card = event.target.closest('[data-kl-addon-card]');
      if (!card) return;
      if (event.target.closest('[data-kl-addon-add]')) updateCard(card, 'add');
      else if (event.target.closest('[data-kl-addon-plus]')) updateCard(card, 'plus');
      else if (event.target.closest('[data-kl-addon-minus]')) updateCard(card, 'minus');
    });

    syncAll();
    document.addEventListener('cart:updated', syncAll);
    document.addEventListener('cart:refresh', syncAll);
  }

  roots.forEach(initRoot);
})();
